import SuccessInvitationSentModal from './SuccessInvitationSentModal';

export default SuccessInvitationSentModal;
